import { Location } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FundHeaderService } from '@components/products/overview/services/fund-header.service';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { TitleService } from '@services/title.service';
import { Subscription } from 'rxjs';
import { Meta } from '@angular/platform-browser';
import { EnvConfigService } from "@services/env-config.service";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ft-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Input() page;
  breadcrumbs: any = [];
  isBreadcrumbShown = true;
  dataSubscription: Subscription;
  isToolsPage: boolean = false;
  segmentSelected: string;

  constructor(
    private titleService: TitleService,
    private envConfig: EnvConfigService,
    private location: Location,
    private breadcrumbService: BreadcrumbService,
    private fundHeaderService: FundHeaderService,
    private elementRef: ElementRef,
    private metaService: Meta,
    private route: ActivatedRoute,

  ) {
  }

  ngOnInit(): void {
    const home = 'Home';

    if (this.location.path().indexOf('funds-and-solutions/tools') > 0) {
      this.isToolsPage = true;
    }
    if (this.isFundPage()) {
      // console.log("BC: IF");
      this.dataSubscription = this.fundHeaderService
        .getFundHeaderState$()
        .subscribe((state) => {
          this.breadcrumbs = this.breadcrumbService.getBreadcrumbs(
            this.page,
            state.fundName
          );
          console.log(this.breadcrumbs)

          this.addSchema();
        });
    } else {
      console.log(this.breadcrumbs)
      this.breadcrumbs = this.breadcrumbService.getBreadcrumbs(this.page);
      this.addSchema();
    }

    


    this.isBreadcrumbShown = !this.page?.getComponent().getModels()?.pageData
      ?.hideBreadcrumbs;

    // Meta title
    const pageData = this.page?.getComponent().getModels()?.pageData;
    if (!pageData?.metaTitle) {
      if (this.location.path().indexOf('about-us') > 0) {
        this.titleService.setTitle('About Us');
        this.metaService.updateTag(
          {
            property: 'og:title',
            content: 'About Us',
          },
          "property='og:title'"
        );
      } else {
        const lastElement = this.breadcrumbs?.length
          ? this.breadcrumbs[this.breadcrumbs?.length - 1]
          : home;
        const metaTitle = lastElement.name;
        if (metaTitle && !this.isFundPage()) {
          this.titleService.setTitle(metaTitle);
        }
      }
    }
    const isDistributor = this.location.path().includes('/distributor');
    const isSapphireSif = this.location.path().includes('/sapphiresif');
    this.segmentSelected = localStorage.getItem("current-segment");
    if (isSapphireSif) {
      this.segmentSelected = "SapphireSif";
    } else if (isDistributor) {
      this.segmentSelected = "Distributor";
    }


  }

    // Method to return queryParams conditionally
    getQueryParams() {
      const params: any = {};
      const arnCode = this.route.snapshot.queryParams?.arncode;
      const euinCode = this.route.snapshot.queryParams?.euin;
  
      // Add arncode and euin only if the condition is met
      if (arnCode && euinCode) {
        params.arncode = arnCode;
        params.euin = euinCode;
      }
      return params;
    }
  

  isFundPage(): boolean {
    return this.page?.getUrl()?.startsWith('/fund-details') ||
           this.location.path()?.startsWith('/sapphiresif/fund-details');
  }

  private addSchema() {
    const urlRoot = this.envConfig.getEnvConfig()?.baseUrl.replace(/\/$/, "");
    const breadcrumbs = this.breadcrumbs?.map((breadcrumb, i) => ({
      '@type': 'ListItem',
      position: i + 2,
      item: {
        '@type': 'WebPage',
        '@id': breadcrumb.link ? urlRoot + breadcrumb.link : '',
        name: breadcrumb.name,
      },
    }));
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          item: {
            '@type': 'WebPage',
            '@id': urlRoot,
            name: 'Home',
          },
        },
        ...(breadcrumbs ? breadcrumbs : []),
      ],
    };

    // set url of leaf
    schema.itemListElement[schema.itemListElement.length - 1].item['@id'] =
      urlRoot + this.page?.getUrl().replace(/\/_index_$/, '');

    // add to page
    const s = document?.createElement('script');
    s.type = 'application/ld+json';
    s.innerText = JSON.stringify(schema);
    this.elementRef.nativeElement.appendChild(s);
  }

  backClicked() {
    this.location.back();
  }

  ngOnDestroy(): void {
    // Unsubscribe fundHeaderService subscriber.
    this.dataSubscription?.unsubscribe();
  }
}
